import React from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('org_account');
import classNames from 'classnames';
import styles from './UpgradePromptSettingsTab.less';
const stars = require('resources/images/stars.svg');
import { Noun, Verb, trackUe } from '@trello/analytics';

interface ComponentProps {
  buttonUrl: string;
  buttonText: string;
}

export const UpgradePromptSettingsTab = (props: ComponentProps) => {
  const { buttonUrl, buttonText } = props;

  return (
    <div
      className={classNames(
        'window-module',
        'u-clearfix',
        styles.bcPromptHeader,
      )}
    >
      <div className={classNames('setting-item', styles.settingItem)}>
        <div className={styles.bcPromptSparkle}>
          <img alt="sparkle" src={stars} />
        </div>

        <div className="setting-item-detail">
          {format('more-settings', {
            boldTextUpgradeToBc: (
              <strong>{format('bold-text-upgrade-to-bc')}</strong>
            ),
          })}
        </div>

        <div className="setting-item-action">
          <a
            className={classNames(
              'primary',
              'button-link',
              'u-text-align-center',
              styles.bcPromptUpgrade,
            )}
            href={buttonUrl}
            onClick={() =>
              trackUe({
                category: Noun.TEAM_PAGE,
                verb: Verb.OPENS,
                directObj: Noun.TEAM_PAGE_BC_TAB,
                method: 'by clicking upgrade button in team page settings tab',
              })
            }
          >
            {format(buttonText)}
          </a>
        </div>
      </div>
    </div>
  );
};
